import { TarotCardData } from '../types/tarot';
import { FARCASTER_DEEP_LINK } from './farcasterShare';

export interface MetaTagData {
  title: string;
  description: string;
  image: string;
  url: string;
}

// Generate meta tag data for shared card readings
export const generateCardMetaTags = (cards: TarotCardData[]): MetaTagData => {
  if (cards.length === 0) {
    return {
      title: 'STRADAMUS - Crypto Tarot Readings',
      description: 'Discover your daily crypto guidance with mystical tarot readings',
      image: `${window.location.origin}/assets/preview.png`,
      url: FARCASTER_DEEP_LINK
    };
  }

  const cardNames = cards.map(card => card.name).join(', ');
  const firstCard = cards[0];
  
  return {
    title: `🔮 My Tarot Reading: ${cardNames}`,
    description: `Discover your daily crypto guidance! First card: ${firstCard.name} - ${firstCard.meaning}`,
    image: firstCard.image.startsWith('http') ? firstCard.image : `${window.location.origin}${firstCard.image}`,
    url: FARCASTER_DEEP_LINK
  };
};

// Update document meta tags dynamically
export const updateMetaTags = (metaData: MetaTagData): void => {
  // Update title
  document.title = metaData.title;

  // Update or create meta tags
  const metaTags = [
    { property: 'og:title', content: metaData.title },
    { property: 'og:description', content: metaData.description },
    { property: 'og:image', content: metaData.image },
    { property: 'og:url', content: metaData.url },
    { property: 'og:type', content: 'website' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: metaData.title },
    { name: 'twitter:description', content: metaData.description },
    { name: 'twitter:image', content: metaData.image },
    { name: 'twitter:site', content: '@stradamus' },
    { name: 'twitter:creator', content: '@stradamus' },
    { name: 'twitter:image:alt', content: 'Crypto Tarot Reading' },
    { property: 'og:site_name', content: 'STRADAMUS' },    { name: 'description', content: metaData.description }
  ];

  metaTags.forEach(({ property, name, content }) => {
    const selector = property ? `meta[property="${property}"]` : `meta[name="${name}"]`;
    let metaTag = document.querySelector(selector) as HTMLMetaElement;
    
    if (!metaTag) {
      metaTag = document.createElement('meta');
      if (property) metaTag.setAttribute('property', property);
      if (name) metaTag.setAttribute('name', name);
      document.head.appendChild(metaTag);
    }
    
    metaTag.content = content;
  });
};

// Parse cards from URL and update meta tags
export const handleSharedCardUrl = (): TarotCardData[] | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const cardsParam = urlParams.get('cards');
  
  if (!cardsParam) return null;

  try {
    // This would need to be implemented to reconstruct card data from IDs
    // For now, return null to indicate no shared cards to display
    console.log('Shared cards detected:', cardsParam);
    return null;
  } catch (error) {
    console.error('Error parsing shared cards:', error);
    return null;
  }
}; 
